import constate from 'constate';
import useFetchStationDetail from './useFetchStationDetail';

// Separate module from userContext: useFetchStationDetail pulls in
// useApiClient, which consumes useUserLanguage from userContext — bundling
// both constate blocks in one module would re-create the import cycle this
// file structure exists to avoid (see userContext.ts).
const [WeatherStationProvider, useFetchWeatherStationDetail] = constate(
  useFetchStationDetail,
  (value) => ({
    loading: value.loading,
    fetchStationDetail: value.fetchStationDetail,
    stationUpdateRequired: value.stationUpdateRequired,
  }),
);

export {useFetchWeatherStationDetail, WeatherStationProvider};
